import moment from 'moment';
import _ from 'underscore';

class AddAdmissionGroupCustomerCtrl {
  constructor($scope, colorService, customerService, sdkUtils, organizationService, alertService, formHelpersService, monthService) {
    this._$scope = $scope;
    this._colorService = colorService;
    this._customerService = customerService;
    this._sdkUtils = sdkUtils;
    this._organizationService = organizationService;
    this._alertService = alertService;
    this._formHelpersService = formHelpersService;
    this.customer = this._$scope.customer;
    this.editMode = !!this.customer;
    this.searchTerm = null;
    this.loading = false;
    this.updateCustomerForm = {};
    this.months = monthService.list();
    this.currentYear = (new Date()).getFullYear();
    this.canViewCustomerInformation = this._$scope.canViewCustomerInformation;

    this.venue = $scope.venue;
    this.venueBrandColors = this.venue.branding ? {
      primaryColor: this.venue.branding.primaryColor ? colorService.rgbToHex(this.venue.branding.primaryColor.red, this.venue.branding.primaryColor.green, this.venue.branding.primaryColor.blue) : null
    } : {};

    if (!this.venue) throw new Error('add-admission-group-customer directive - venue is required on scope');

    this.onSearchTermChanged = _.debounce(this.searchCustomers, 400);

    if (this.customer) {
      this.updateCustomerForm.name = this.customer.name;
      this.updateCustomerForm.email = this.customer.email;
      this.updateCustomerForm.phone = this.customer.phone;
      this.updateCustomerForm.ref = this.customer.ref;
      this.updateCustomerForm.tags = this.customer.tags;
      this.updateCustomerForm.notes = this.customer.notes;
      this.updateCustomerForm.vip = this.customer.vip;
      this.updateCustomerForm.birthdayMonth = this.customer.birthdayMonth;
      this.updateCustomerForm.birthdayDay = this.customer.birthdayDay;
      this.updateCustomerForm.birthdayYear = this.customer.birthdayYear;
      this.updateCustomerForm.gender = this.customer.gender;
    }

    if (!this.canViewCustomerInformation) {
      delete this.customer;
      this.updateCustomerForm = {};
      this.createNewCustomer = false;
    }
  }

  enableNewCustomer($event) {
    if ($event) $event.preventDefault();

    this.createNewCustomer = true;
    this.updateCustomerForm = {
      name: this.searchTerm
    };
  }

  selectCustomer(customer, $event) {
    if (!customer) throw new Error('customer');
    if ($event) $event.preventDefault();

    if (this._$scope.onAddedOrUpdated) {
      this._$scope.onAddedOrUpdated(customer);
    }
  }

  removeCustomer($event) {
    if ($event) $event.preventDefault();

    delete this.customer;
    this.createNewCustomer = false;
  }

  updateCustomer(angularForm, $event) {
    if ($event) $event.preventDefault();

    this.submitted = true;

    if (!angularForm.$valid) return null;

    this.saving = true;

    const currentUserOrganization = this._organizationService.getCurrentOrganization();
    const data = this.createNewCustomer ? this.updateCustomerForm : this._formHelpersService.getChangedFormValues(angularForm);

    if (this.createNewCustomer) {
      data.venueId = this.venue.id;
    }

    if (data.tags && data.tags.length) {
      data.tags = data.tags.join(',');
    } else if (!this.updateCustomerForm.tags || this.updateCustomerForm.tags.length === 0) {
      data.tags = null;
    }

    const promise = !this.createNewCustomer ? this._customerService.updateByIdAndOrganizationId(this.customer.id, currentUserOrganization.id, data) :
      this._customerService.createByOrganizationId(currentUserOrganization.id, data);

    return promise
      .then(customer => {
        this.customer = customer;
        this.saving = false;

        if (this._$scope.onAddedOrUpdated) {
          this._$scope.onAddedOrUpdated(customer);
        }
      })
      .catch(response => {
        this.saving = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }

  searchCustomers() {
    this.loading = true;

    const currentUserOrganization = this._organizationService.getCurrentOrganization();

    return this._customerService.searchByOrganizationId(currentUserOrganization.id, {
        venueId: this.venue.id,
        name: this.searchTerm
      })
      .then(customers => {
        this.customers = customers.map(customer => {
          if (customer.stats) {
            if (customer.stats.firstVisit) customer.stats.firstVisit = moment.utc(customer.stats.firstVisit);
            if (customer.stats.latestVisit) customer.stats.latestVisit = moment.utc(customer.stats.latestVisit);
          }

          return customer;
        });
        this.loading = false;
      })
      .catch(response => {
        this.loading = false;
        this._alertService.error(this._sdkUtils.getErrorFromResponse(response));
      });
  }
}

AddAdmissionGroupCustomerCtrl.$inject = [
  '$scope',
  'colorService',
  'jsSdk.customer',
  'jsSdk.utils',
  'organizationService',
  'alertService',
  'formHelpersService',
  'monthService'
];

export default AddAdmissionGroupCustomerCtrl;



// WEBPACK FOOTER //
// ./src/directives/addAdmissionGroupCustomer/controller.js